import React from 'react';
import { useSelector } from 'react-redux';
import { PromoSection as PromoSectionComponent } from '@yme/organisms/promo-section';
import { getCommonLabels, getRTL } from '@yme/selectors/index';
export function PromoSection(props) {
    const commonLabels = useSelector(getCommonLabels);
    const isRightToLeft = useSelector(getRTL);
    if (!props?.title || !props?.description || !props?.image) {
        return null;
    }
    const { isRemoveBottomIndent, image, title, subtitle = '', description, buttonLink } = props;
    return (React.createElement(PromoSectionComponent, { image: image, title: title, subtitle: subtitle, description: description, buttonLink: buttonLink, isRightToLeft: isRightToLeft, isRemoveBottomIndent: isRemoveBottomIndent, buttonLabel: commonLabels?.common_learnMore_link || '' }));
}
PromoSection.displayName = 'PromoSection_AEMComponent';
